import { createContext, type ReactNode } from 'react';

import { usePrivyWallet, type UserSuiWalletState } from './use-privy-wallet';

export const SuiWalletContext = createContext<UserSuiWalletState | null>(null);

export function SuiWalletProvider({ children }: { children: ReactNode }) {
  const wallet = usePrivyWallet();

  return <SuiWalletContext.Provider value={wallet}>{children}</SuiWalletContext.Provider>;
}
